import React, { FC } from "react";
import { Flex } from "../../atoms/flex";
import { Title } from "../../atoms/title";
import { Text } from "../../atoms/text";
import "./savings-list-item.css";

interface SavingsListItemProps {
  value?: string | number | null | undefined;
  text?: string;
  unit?: string;
  noUnitSpace?: boolean;
  className?: string;
  loading?: boolean;
}

/**
 * Savings list item component
 */
export const SavingsListItem: FC<SavingsListItemProps> = ({
  value,
  text,
  unit,
  noUnitSpace,
  className,
  loading,
}) => (
  <Flex className={`SavingsListItem ${className || ""}`}>
    <Title
      tag="h2"
      text={`${value}${noUnitSpace ? "" : " "}${unit}`}
      loading={loading}
    />
    <Text align="left" size={19} loading={loading}>
      {text}
    </Text>
  </Flex>
);
